import { CombinedError } from "../graphql/index.js";
class NotAuthenticatedError extends Error {
    response;
    constructor(response){
        super('Not authenticated'), this.response = response;
        Object.setPrototypeOf(this, NotAuthenticatedError.prototype);
    }
}
function isNotAuthenticatedError(error) {
    return error instanceof NotAuthenticatedError || error instanceof CombinedError && '[Network] Not authenticated' === error.message;
}
export { NotAuthenticatedError, isNotAuthenticatedError };

//# sourceMappingURL=NotAuthenticatedError.js.map